<!-- =========================================================================================
  File Name: AttendeeList.vue
  Description: Attendee List
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Webspiders
  Author URL: https://www.webspiders.com
========================================================================================== -->
<style lang="scss">
.mail-btn {
  float: right;
  background: #869fb7;
  background-image: inherit !important;
}
.holamundo.customnewpopup .vs-popup {
  width: auto !important;
}
button.vs-component.vs-button.ml-3.setting-btn.vs-button-primary.vs-button-border {
  padding: 6px !important;
}
.setting-btn span img {
  height: 20px;
  width: 20px;
}
.file-up-section {
  text-align: center;
  border: 2px dashed #c8c8c8;
  margin-top: 15px;
  padding: 10px;
  border-radius: 5px;
}
.file-up-section p {
  color: #4c8af6;
  font-weight: 600;
  font-size: 16px;
  margin-bottom: 5px;
}
.header-custome {
  margin-bottom: 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.knowlg-base-wrap-sec a {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-size: 12px;
}
.knowlg-base-wrap-sec a span {
  margin-right: 10px;
  line-height: 0;
}
.option-inner-wrap {
  margin: 0;
  padding: 0;
}
.option-inner-wrap li {
  list-style: none;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
}
.header-custome span {
  font-size: 15px;
}
</style>
<template>
  <div id="page-user-list">
    <div class="header-custome">
      <h3>
        Checkout Forms
        <span>{{
          gridSelectedRows ? "Rows Selected: " + gridSelectedRows : ""
        }}</span>
      </h3>
      <div class="knowlg-base-wrap-sec">
        <a href="/pages/knowledge-base/category-attendees/question-2">
          <span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="feather feather-help-circle"
            >
              <circle cx="12" cy="12" r="10" />
              <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" />
              <line x1="12" y1="17" x2="12.01" y2="17" />
            </svg>
          </span>
          Need help with this section?
        </a>
      </div>
    </div>
    <div class="vx-card p-6">
      <div class="flex flex-wrap items-center">
        <!-- ITEMS PER PAGE -->
        <div class="flex-grow">
          
        </div>
        <!--ADD Attendee-->
        <vs-button type="gradient mr-4" v-on:click="addRecord ()">Add New</vs-button>
        <vs-input
          class="sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4"
          v-model="searchQuery"
          @input="updateSearchQuery"
          placeholder="Search..."
        />

        <!-- ACTION - DROPDOWN -->
        <!-- <vs-dropdown vs-trigger-click class="cursor-pointer">
          <div
            class="p-3 shadow-drop rounded-lg d-theme-dark-light-bg cursor-pointer flex items-end justify-center text-lg font-medium w-32"
          >
            <span class="mr-2 leading-none">Actions</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>

          <vs-dropdown-menu>
            <vs-dropdown-item @click="exportSelected()">
              <span class="flex items-center">
                <feather-icon
                  icon="FileIcon"
                  svgClasses="h-4 w-4"
                  class="mr-2"
                />
                <span>Download CSV</span>
              </span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown> -->
       
      </div>

      <!-- AgGrid Table -->
      <ag-grid-vue
        ref="agGridTable"
        :components="components"
        :gridOptions="gridOptions"
        class="ag-theme-material w-full my-4 ag-grid-table"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="regformData"
        rowSelection="multiple"
        rowMultiSelectWithClick="false"
        suppressRowClickSelection="true"
        colResizeDefault="shift"
        :animateRows="true"
        :floatingFilter="true"
        :pagination="true"
        :paginationPageSize="paginationPageSize"
        :suppressPaginationPanel="true"
        :enableRtl="$vs.rtl"
        @selection-changed="onSelectionChanged"
      ></ag-grid-vue>
    </div>
  </div>
</template>
<script>
//import db from "@/firebase/firebaseInit.ts";
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";
import vSelect from "vue-select";
import "quill/dist/quill.snow.css";
import { quillEditor } from "vue-quill-editor";
import moment from "moment-timezone";

// Store Module
import moduleTicketManagement from "@/store/ticket-management/moduleTicketManagement.js";
import ls from "@/common/localStorage";

// Cell Renderer
import CellRendererActions from "./cell-renderer/CellRendererActions.vue";

//console.log(db);
//const event_collectionName = 'sayek-dev';
//var Session_Event_TZ = ls.getSessionValueByKey("Session_Event_TZ");
var eventID = ls.getSessionValueByKey("Session_Event_Id");

export default {
  components: {
    AgGridVue,
    vSelect,
    quillEditor,
    CellRendererActions,
  },
  data() {
    return {
      searchQuery: "",
      totalAmount: 0,
      gridSelectedRows: 0,
      gridApi: null,
      gridOptions: {},
      defaultColDef: {
        sortable: true,
        resizable: true,
        suppressMenu: true,
      },
      regformData: [],
      columnDefs: [
        {
          headerName: "FormId",
          field: "FormId",
          width: 40,
          filter: false,
          checkboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          headerCheckboxSelection: true,
        },
        {
          headerName: "Form Title",
          field: "FormTitle",
          filter: true,
          width: 300,
        },
        {
          headerName: "Registration Types",
          field: "RegistrationTypes",
          cellRenderer: (data) => {
            if(data.value){
              let names =  data.value.map(row=>{
                return row.RegistrationType
              })
              return names.toString()
            } else return 'NA'
          },
          filter: true,
          width: 300,
        },
        {
          headerName: "Actions",
          field: "transactions",
          width: 200,
          cellRendererFramework: "CellRendererActions",
          cellRendererParams: (params) => {
            return {
              FormId: params.data.FormId
            };
          },
        },

      ],

      // Cell Renderer Components
      components: {
        CellRendererActions,
      },
    };
  },
  watch: {
  },
  computed: {
    paginationPageSize() {
      if (this.gridApi) return this.gridApi.paginationGetPageSize();
      else return 10;
    },
    totalPages() {
      if (this.gridApi) return this.gridApi.paginationGetTotalPages();
      else return 0;
    },
    currentPage: {
      get() {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1;
        else return 1;
      },
      set(val) {
        this.gridApi.paginationGoToPage(val - 1);
      },
    },    
  },
  methods: {
    onSelectionChanged() {
      let selectedRows = this.gridApi.getSelectedRows();
      this.gridSelectedRows = selectedRows.length;
    },
    SetTimeByZone: function (strDateTime, timeZone) {
      var date = moment
        .tz(strDateTime, timeZone)
        .format("MMM DD, YYYY hh:mm A");
      return date;
    },
    getSettings() {
      this.$vs.loading();

      this.$store.dispatch("TicketManagement/getSettings").then((res) => {
        this.settingsData = res;
        this.popupActive2 = true;
        this.$vs.loading.close();
      });
    },
    exportSelected() {
      let selectedRows;
      debugger;
      selectedRows = this.gridApi.getSelectedRows();
      //console.log(selectedRows);
      if (selectedRows.length > 0) {
        this.popupActiveExport = true;
        var datarowh = [];
        let cellIndex = [];
        let DynamicFieldsIndex = 4;
        let DynamicFieldsStartIndex = 4;

        datarowh.push("Salutation");
        datarowh.push("Name");
        datarowh.push("Email");
        datarowh.push("Phone");
        datarowh.push("Company");
        datarowh.push("Title");
        datarowh.push("MailingAddress");
        datarowh.push("Country");
        datarowh.push("State");
        datarowh.push("City");
        datarowh.push("ZIP");

        //---------------------------
        datarowh.push("Payment Status");
        datarowh.push("Transaction ID");
        datarowh.push("Amount");
        datarowh.push("Date");
        datarowh.push("Channel");
        datarowh.push("RegistrationType");
        datarowh.push("PaymentRetryURL");
        datarowh.push("RSVPCode");

        var AttendeeData = [];
        let Header = [];
        let Data = [];

        selectedRows.filter((row) => {
          if (row.DynamicFields) {
            let DynamicFields = Object.values(row.DynamicFields);
            DynamicFields.filter(function (rowfeild) {
              if (rowfeild.label) {
                let label = rowfeild.label.replace(",", "-");
                if (!datarowh.includes(label)) {
                  cellIndex.push({
                    index: DynamicFieldsIndex,
                    label: label,
                    value: rowfeild.value,
                  });
                  datarowh.push(label);
                  DynamicFieldsIndex++;
                }
              }
            });
          }
        });
        var customDomain = ls.getSessionValueByKey("CustomDomain");
        customDomain = "https://" + ls.getSessionValueByKey("CustomDomain");
        // alert(customDomain);

        selectedRows.map((row) => {
          //---------------------------------------------------------
          let datarowv = [];
          var salutation = "";
          salutation = row.Salutation == undefined ? "" : row.Salutation;
          datarowv.push(salutation);
          var name = "";
          name = row.Name == undefined ? "" : row.Name;
          datarowv.push(
            name.replace("#", "").replace("#", "").replace("#", "")
          );

          var Email = "";
          Email = row.Email == undefined ? "" : row.Email;
          datarowv.push(
            Email.replace("#", "").replace("#", "").replace("#", "")
          );

          var Phone = "";
          Phone = row.Phone == undefined ? "" : row.Phone;
          datarowv.push(
            Phone.replace("#", "").replace("#", "").replace("#", "")
          );

          var Company = "";
          Company = row.Company == undefined ? "" : row.Company;
          datarowv.push(
            Company.replace("#", "")
              .replace("#", "")
              .replace("#", "")
              .replace("#", "")
              .replace(/[, ]+/g, " ")
              .replace(/#(\S)/g, " ")
          );

          var Designation = "";
          Designation = row.Designation == undefined ? "" : row.Designation;
          datarowv.push(
            Designation.replace("#", "")
              .replace("#", "")
              .replace("#", "")
              .replace(/[, ]+/g, " ")
              .replace(/#(\S)/g, " ")
          );

          var MailingAddress = "";
          MailingAddress =
            row.MailingAddress == undefined ? "" : row.MailingAddress;
          datarowv.push(
            MailingAddress.replace("#", "")
              .replace("#", "")
              .replace("#", "")
              .replace("#", "")
              .replace("#", "")
              .replace(/[, ]+/g, " ")
              .replace(/#(\S)/g, " ")
          );

          var Country = "";
          Country = row.Country == undefined ? "" : row.Country;
          datarowv.push(
            Country.replace("#", "")
              .replace("#", "")
              .replace("#", "")
              .replace(/[, ]+/g, " ")
              .replace(/#(\S)/g, " ")
          );

          var State = "";
          State = row.State == undefined ? "" : row.State;
          datarowv.push(State.replace(/[, ]+/g, " ").replace(/#(\S)/g, " "));

          var City = "";
          City = row.City == undefined ? "" : row.City;
          datarowv.push(
            City.replace("#", "")
              .replace("#", "")
              .replace("#", "")
              .replace(/[, ]+/g, " ")
          );

          var Zip = "";
          Zip = row.Zip == undefined ? "" : row.Zip;
          datarowv.push(
            Zip.replace("#", "")
              .replace("#", "")
              .replace("#", "")
              .replace(/[, ]+/g, " ")
          );
          //----------------------------------------------------------------------------------

          var PaymentStatus = "";
          if (row.Payment != undefined) {
            PaymentStatus =
              row.Payment.Status == undefined ? "" : row.Payment.Status;
            datarowv.push(PaymentStatus);

            var TransactionId = "";
            TransactionId =
              row.Payment.TransactionId == undefined
                ? ""
                : row.Payment.TransactionId;
            datarowv.push(TransactionId);
            var Amount = "";
            Amount = row.Payment.Amount == undefined ? "" : row.Payment.Amount;
            datarowv.push(Amount);
            var dateTm = "";
            dateTm =
              row.Payment.Created == undefined
                ? ""
                : new Date(row.Payment.Created.seconds * 1000);
            datarowv.push(dateTm);
            var Source = "";
            var Source =
              row.Payment.Source == undefined ? "" : row.Payment.Source;
            datarowv.push(Source);
          }
          var RegistrationType = "";
          RegistrationType =
            row.RegistrationType == undefined ? "" : row.RegistrationType;
          datarowv.push(RegistrationType);

          var PaymentRetryURL = "";
          if (PaymentStatus != "PAID") {
            PaymentRetryURL =
              customDomain +
              "/paymentstatus" +
              "/" +
              eventID +
              "/" +
              row.Email;
            //   console.log();
            //datarowv.push(PaymentRetryURL);
          }
          datarowv.push(PaymentRetryURL);
          var RSVPCode = "";
          RSVPCode = row.RSVPCode == undefined ? "" : row.RSVPCode;
          datarowv.push(RSVPCode);
          //---------------------------------------------------------------------------------

          let cellval = DynamicFieldsStartIndex;
          if (row.DynamicFields) {
            let DynamicFields = Object.values(row.DynamicFields);
            cellIndex.filter(function (cellfeild) {
              let cellvalue = "";
              DynamicFields.filter((rowf) => {
                if (
                  rowf.label.replace(/[, ]+/g, "") ==
                  cellfeild.label.replace(/[, ]+/g, "")
                ) {
                  if (Array.isArray(rowf.value)) {
                    let arr = rowf.value.map(function (s) {
                      return s.replace(/[, ]+/g, "");
                    });
                    cellvalue = arr.join("|");
                  } else {
                    cellvalue = rowf.value.replace(/#(\S)/g, " ");
                  }
                }
              });
              debugger;

              datarowv.push(cellvalue.replace(/[/ ]+/g, " "));
              cellval++;
            });
          }

          //---------------------------------------------------------

          Data.push(datarowv);
        });
        Header.push(datarowh);
        debugger;
        let csvContent = "data:text/csv;charset=utf-8,";
        var dt = new Date().toISOString().slice(0, 10);
        AttendeeData = Header.concat(Data);
        AttendeeData.forEach(function (rowArray) {
          let row = rowArray.join(",");
          csvContent += row + "\r\n";
        });
        console.log(JSON.stringify(csvContent));
        var filename = "PaidRegistrantExport_" + "_" + dt + ".csv";
        var encodedUri = encodeURI(csvContent);
        var link = document.createElement("a");
        link.setAttribute("href", encodedUri);
        //link.setAttribute("id", "Participance_RT_" + row.TableId);
        link.setAttribute("download", filename);
        document.body.appendChild(link); // Required for FF

        link.click();
        //---------------------------------------------------------------
      } else {
        this.$vs.dialog({
          type: "alert",
          color: "warning",
          title: "Download Reports",
          text: "Please select atleast one attendee to download. ",
          //accept: this.deleteRecord,
          acceptText: "OK",
        });
      }
    },
    saveSettings() {
      this.$vs.loading();
      this.$store
        .dispatch("TicketManagement/saveSettings", {
          settingsData: this.settingsData,
        })
        .then((res) => {
          this.$vs.notify({
            color: "success",
            position: "top-center",
            title: "Settings",
            text: res.message,
          });
          this.$vs.loading.close();
        });
    },
    changeStatus(Status) {
      let selectedRows;
      selectedRows = this.gridApi.getSelectedRows();
      if (selectedRows.length) {
        this.$vs.loading();
        this.$store
          .dispatch("TicketManagement/changeStatus", {
            data: selectedRows,
            Status: Status,
          })
          .then((res) => {
            //alert(res.message)
            this.$vs.notify({
              color: "success",
              position: "top-center",
              title: "Status",
              text: res.message,
            });
            this.gridApi.deselectAll();
            this.$vs.loading.close();
            this.$store.dispatch("TicketManagement/fetchAttendees");
          })
          .catch((err) => {
            //console.error(err)
            this.$vs.loading.close();
          });
      } else {
        this.$vs.dialog({
          type: "alert",
          position: "top-center",
          color: "warning",
          title: "Status",
          text: "Please Select a Row",
          //accept: this.deleteRecord,
          acceptText: "OK",
        });
      }
    },
    setColumnFilter(column, val) {
      const filter = this.gridApi.getFilterInstance(column);
      let modelObj = null;

      if (val !== "all") {
        modelObj = { type: "equals", filter: val };
      }

      filter.setModel(modelObj);
      this.gridApi.onFilterChanged();
    },
    resetColFilters() {
      // Reset Grid Filter
      this.gridApi.setFilterModel(null);
      this.gridApi.onFilterChanged();

      // Reset Filter Options
      this.roleFilter = this.statusFilter = this.isVerifiedFilter = this.departmentFilter = {
        label: "All",
        value: "all",
      };

      this.$refs.filterCard.removeRefreshAnimation();
    },
    updateSearchQuery(val) {
      this.gridApi.setQuickFilter(val);
    },
    addRecord() {
      this.$router.push("/event/addcheckoutform").catch(() => {});
    }
  },
  mounted() {
    this.gridOptions.api.showLoadingOverlay()
    this.gridApi = this.gridOptions.api;

    /* =================================================================
      NOTE:
      Header is not aligned properly in RTL version of agGrid table.
      However, we given fix to this issue. If you want more robust solution please contact them at gitHub
    ================================================================= */
    if (this.$vs.rtl) {
      const header = this.$refs.agGridTable.$el.querySelector(
        ".ag-header-container"
      );
      header.style.left = `-${String(
        Number(header.style.transform.slice(11, -3)) + 9
      )}px`;
    }
  },
  created() {
    if (!moduleTicketManagement.isRegistered) {
      this.$store.registerModule(
        "TicketManagement",
        moduleTicketManagement
      );
      moduleTicketManagement.isRegistered = true;
    } 
    this.$store.dispatch("TicketManagement/fetchCheckoutForms").then(res=>{
      this.regformData = res
    })
  },
};
</script>

<style lang="scss">
#page-user-list {
  .user-list-filters {
    .vs__actions {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-58%);
    }
  }
}
</style>